import api from './api';

export const saveSecret = (service, block) =>
  api.post('/admin/server-secrets', { service, block }).then(r => r.data);

// Stripe updates (webhook) — one button; the signing key never leaves the server.
export const getStripeWebhookStatus = () =>
  api.get('/admin/server-secrets/stripe-webhook').then(r => r.data);
export const connectStripeWebhook = () =>
  api.post('/admin/server-secrets/stripe-webhook/connect').then(r => r.data);
